import CommonOfferPrice from 'common/components/entities/OfferPriceNew'
import { PaymentMethodEnum } from 'common/enums/PaymentMethodEnum'
import { OfferPriceInterface } from 'common/types/entities/OfferPriceInterface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { useFinalAmount } from 'publisher/pages/offer-page/hooks/use-final-amount'
import { usePage, usePayment } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { setActivePricePlanId } from 'publisher/store/payment/paymentActions'
import {
  getActivePaymentMethod,
  getCheckedBump,
  getCheckedCoupon,
  getProduct,
  isOnlyPersonalAvailable,
} from 'publisher/store/payment/paymentSelectors'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useCalculatedPricePlans } from 'src/publisher/hooks/use-calculated-price-plans'
import { useFetchOfferPricing } from 'src/publisher/hooks/use-fetch-offer-pricing'
import { useOfferPricing } from 'src/publisher/hooks/use-offer-pricing'

function OfferPrice({ entity }: { entity: OfferPriceInterface }) {
  const dispatch = useDispatch()

  const [isClient, setIsClient] = useState(false)
  const locale = usePage(pageSelectors.getLocale)
  const coupon = usePayment(getCheckedCoupon)
  const bump = usePayment(getCheckedBump)
  const activePaymentMethod = usePayment(getActivePaymentMethod)

  const { pricePlans, activePlanId } = useCalculatedPricePlans()
  const bumpPlan = bump?.pricePlans[0]

  const isVatNotChargeable =
    usePayment(isOnlyPersonalAvailable) ||
    activePaymentMethod === PaymentMethodEnum.RazorpayCard

  const product = usePayment(getProduct)
  const productBump = bump?.product || null

  useFetchOfferPricing()

  const {
    physicalMainOfferPricing,
    physicalBumpOfferPricing,
    digitalBumpOfferPricing,
    digitalOfferPricings,
  } = useOfferPricing()

  useEffect(() => {
    setIsClient(true)
  }, [])

  // includes all taxes and shipping fees
  const finalAmount = useFinalAmount()

  return (
    isClient && (
      <StyleWrapper
        margin={entity.margin}
        appearance={entity.appearance}
        mobileMargin={entity.mobileMargin}
      >
        <CommonOfferPrice
          attrId={entity.htmlAttrId}
          plans={pricePlans}
          activePlanId={activePlanId}
          bumpPlan={bumpPlan}
          coupon={coupon}
          mainOfferPricing={physicalMainOfferPricing}
          bumpOfferPricing={physicalBumpOfferPricing}
          pricePlansPricing={digitalOfferPricings}
          bumpPlanPricing={digitalBumpOfferPricing}
          product={product}
          productBump={productBump}
          finalAmount={finalAmount}
          isVatNotChargeable={isVatNotChargeable}
          togglePricePlan={(pricePlanId: number) =>
            dispatch(setActivePricePlanId(pricePlanId))
          }
          customDescription={entity.customDescription}
          locale={locale}
          nameFontSize={entity.nameFontSize}
          mobileNameFontSize={entity.mobileNameFontSize}
          nameFontStyle={entity.nameFontStyle}
          mobileNameFontStyle={entity.mobileNameFontStyle}
          nameFontWeight={entity.nameFontWeight}
          mobileNameFontWeight={entity.mobileNameFontWeight}
          nameFontFamily={entity.nameFontFamily}
          mobileNameFontFamily={entity.mobileNameFontFamily}
          nameLineHeight={entity.nameLineHeight}
          mobileNameLineHeight={entity.mobileNameLineHeight}
          nameColor={entity.nameColor}
          mobileNameColor={entity.mobileNameColor}
          amountFontSize={entity.amountFontSize}
          mobileAmountFontSize={entity.mobileAmountFontSize}
          amountFontStyle={entity.amountFontStyle}
          mobileAmountFontStyle={entity.mobileAmountFontStyle}
          amountFontWeight={entity.amountFontWeight}
          mobileAmountFontWeight={entity.mobileAmountFontWeight}
          amountFontFamily={entity.amountFontFamily}
          mobileAmountFontFamily={entity.mobileAmountFontFamily}
          amountLineHeight={entity.amountLineHeight}
          mobileAmountLineHeight={entity.mobileAmountLineHeight}
          amountColor={entity.amountColor}
          mobileAmountColor={entity.mobileAmountColor}
          descriptionFontSize={entity.descriptionFontSize}
          mobileDescriptionFontSize={entity.mobileDescriptionFontSize}
          descriptionFontStyle={entity.descriptionFontStyle}
          mobileDescriptionFontStyle={entity.mobileDescriptionFontStyle}
          descriptionFontWeight={entity.descriptionFontWeight}
          mobileDescriptionFontWeight={entity.mobileDescriptionFontWeight}
          descriptionFontFamily={entity.descriptionFontFamily}
          mobileDescriptionFontFamily={entity.mobileDescriptionFontFamily}
          descriptionLineHeight={entity.descriptionLineHeight}
          mobileDescriptionLineHeight={entity.mobileDescriptionLineHeight}
          descriptionColor={entity.descriptionColor}
          mobileDescriptionColor={entity.mobileDescriptionColor}
        />
      </StyleWrapper>
    )
  )
}

export default OfferPrice
